import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { STALLS } from '../../data/games';
import { apiPost } from '../../utils/apiClient';
import { setCoinsLeft } from '../../store/uiSlice';
import {
  parseTimeLabel,
  readStoredElapsedSeconds,
  useCarnivalTimer,
  writeStoredElapsedSeconds,
} from '../../hooks/useCarnivalTimer';
import './HubPage.css';

export default function HubPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const coinsLeft = useSelector((s) => s.ui.coinsLeft);
  const [timerSeed, setTimerSeed] = useState(null);
  const { display: timerDisplay } = useCarnivalTimer({ running: false, seedSeconds: timerSeed });

  useEffect(() => {
    if (!user?.userId || !user?.sessionId) return;
    (async () => {
      try {
        const ensured = await apiPost('/ensureUser', {
          userId: user.userId,
          name: user.name,
          email: user.email,
          userType: user.roles || user.role || '',
        });
        dispatch(setCoinsLeft(ensured.coins_left ?? 0));

        let seconds = 0;
        if (ensured.created) {
          seconds = 0;
        } else {
          const fromStorage = readStoredElapsedSeconds(user.userId, user.sessionId);
          const fromDb = parseTimeLabel(ensured.totaltime) ?? 0;
          // Prefer live session storage (updated during games); DB can be stale
          seconds = fromStorage > 0 ? fromStorage : fromDb;
        }

        writeStoredElapsedSeconds(seconds, user.userId, user.sessionId);
        setTimerSeed(seconds);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [user?.userId, user?.sessionId, user?.name, user?.email, user?.roles, user?.role, dispatch]);

  const openStall = (stall) => {
    const isDemo =
      user?.sessionId === 'demobypass' ||
      user?.role === 'demobypass' ||
      user?.source === 'DEMO';
    if (isDemo) {
      Swal.fire({
        title: 'Subscribe to any plan to enjoy the games.',
        icon: 'success',
        confirmButtonText: 'Close',
        customClass: { confirmButton: 'hf-swal-close', popup: 'hf-swal-popup' },
        buttonsStyling: false,
      }).then(() => {
        window.location.href = 'https://extramileplay.com/plans';
      });
      return;
    }
    navigate(stall.route);
  };

  return (
    <div
      className="hub-page hub-bg"
      style={{
        '--ic-bg': 'url(/img/mainbg.png)',
        '--ic-bg-mob': 'url(/img/mainbgmob.png)',
      }}
    >
      <div className="hub-topbar">
        <div className="hub-timer">Time: {timerDisplay}</div>
        <div className="hub-points">Total Points: {coinsLeft ?? 0}</div>
      </div>

      <div className="hub-stalls alltabs">
        {STALLS.map((stall) => (
          <button
            key={stall.id}
            type="button"
            className="hub-stall spending-img1"
            onClick={() => openStall(stall)}
            aria-label={stall.title}
          >
            <img src={stall.tile} alt={stall.title} />
          </button>
        ))}
      </div>
    </div>
  );
}
